/*
  Footer reveal: marks the document while the reveal panel is the thing on screen.

  One IntersectionObserver on the runway element, no scroll listener and no
  per-frame work. It adds `footer-reveal-open` to <html> the moment the runway
  starts entering the viewport, which is exactly the moment the footer's bottom
  edge rises above the bottom of the window and the image starts being uncovered.

  The class is used by snippets/footer-reveal.liquid to fade out floating widgets
  that would otherwise sit on top of the image -- the Shopify Inbox chat launcher
  in particular, which floats at the bottom left and covered a policy link there.

  ?frdebug=1 on any URL turns on an on-device readout (see debug() below): the
  snippet's CSS paints the header band lime and the reveal panel magenta, and a
  fixed <pre> prints what the engine computed for the band, <main> and the panel,
  plus a hit-test just above <main>. One phone screenshot then answers "is the
  band there, and what is painted at the gap" -- the leak around the floating
  nav did not reproduce in Chrome, only on the client's iPhone, and this is how
  the next report gets facts instead of another guess. Same play as ?otdebug=1
  on the Origins page.
*/
(function () {
  if (window.__footerRevealInitialized) return;
  window.__footerRevealInitialized = true;

  var OPEN_CLASS = 'footer-reveal-open';
  var NEAR_CLASS = 'footer-reveal-near';
  var ARMED_CLASS = 'footer-reveal-armed';

  function init() {
    var runway = document.querySelector('.footer-reveal__runway');
    if (!runway || typeof IntersectionObserver === 'undefined') return;
    var html = document.documentElement;

    new IntersectionObserver(function (entries) {
      html.classList.toggle(OPEN_CLASS, entries[entries.length - 1].isIntersecting);
    }, { threshold: 0 }).observe(runway);

    // Second observer, half a screen early: the panel is only PAINTED while
    // this one says the runway is near (see the matching rule in the snippet).
    // On iOS Safari a viewport-fixed layer is re-anchored a frame or two late
    // during a rubber-band bounce, so a fast fling back to the top of the page
    // exposed a strip of the image above the marquee until the bounce settled
    // (client, 2026-09-13). Nothing in page code changes how iOS times that;
    // not painting the panel anywhere near the top removes the layer that was
    // leaking. Half a screen is enough headroom for the observer's ~2-3 frame
    // latency on a fast fling towards the footer, and small enough that a very
    // short page still hides the panel at scroll 0. The armed class is added
    // inside this callback, after the near state is known, so the panel never
    // spends a frame hidden while the runway is already on screen; and it is
    // only ever added by JS, so without JS the panel stays visible.
    new IntersectionObserver(function (entries) {
      html.classList.toggle(NEAR_CLASS, entries[entries.length - 1].isIntersecting);
      html.classList.add(ARMED_CLASS);
    }, { threshold: 0, rootMargin: '0px 0px 50% 0px' }).observe(runway);
  }

  function debug() {
    if (!/[?&]frdebug=1(&|$)/.test(location.search)) return;
    document.documentElement.classList.add('footer-reveal-debug');

    var main = document.getElementById('MainContent');
    var head = document.querySelector('body > .footer-reveal__head');
    var panel = document.querySelector('.footer-reveal');
    var out = document.createElement('pre');
    out.className = 'footer-reveal-debug__hud';

    function rect(el) {
      if (!el) return 'MISSING';
      var r = el.getBoundingClientRect();
      return Math.round(r.top) + '..' + Math.round(r.bottom) + ' w' + Math.round(r.width);
    }
    function desc(el) {
      return el.tagName.toLowerCase() + (el.id ? '#' + el.id.slice(-14) : '') + (el.classList.length ? '.' + el.classList[0] : '');
    }
    function render() {
      var cs = head ? getComputedStyle(head) : null;
      var ps = head ? getComputedStyle(head, '::before') : null;
      var mainTop = main ? main.getBoundingClientRect().top : 0;
      var y = Math.max(0, Math.round(mainTop - 10));
      var hit = document.elementsFromPoint(4, y).slice(0, 5).map(desc).join(' > ');
      out.textContent = [
        'FR ' + (window.Shopify && Shopify.theme ? Shopify.theme.id + ' ' + Shopify.theme.role : '?') +
          ' vp ' + innerWidth + 'x' + innerHeight + ' sy ' + Math.round(scrollY),
        'head ' + rect(head) + (cs ? ' ' + cs.display + '/' + cs.position + '/z' + cs.zIndex : ''),
        'band ' + (ps ? ps.display + '/' + ps.position + ' bottom ' + ps.bottom + ' h ' + ps.height + ' z' + ps.zIndex + ' bg ' + ps.backgroundColor : '-'),
        'main ' + rect(main) + (main ? ' z' + getComputedStyle(main).zIndex : '') + ' body ' + getComputedStyle(document.body).display,
        'panel ' + rect(panel) + (panel ? ' ' + getComputedStyle(panel).position + '/z' + getComputedStyle(panel).zIndex + ' ' + getComputedStyle(panel).visibility : ''),
        'cls ' + (document.documentElement.className.split(/\s+/).filter(function (c) { return c.indexOf('footer-reveal-') === 0; }).join(' ') || 'none'),
        'hit 4,' + y + ': ' + hit,
        navigator.userAgent.replace(/^Mozilla\/5\.0 /, '').slice(0, 96)
      ].join('\n');
    }

    document.body.appendChild(out);
    render();
    addEventListener('scroll', render, { passive: true });
    addEventListener('resize', render);
    // The near/open classes land from IntersectionObserver callbacks, which run
    // after the scroll event that last redrew the readout, so the cls line was
    // one event stale. render() never touches the class attribute, so this
    // cannot loop.
    new MutationObserver(render).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); debug(); });
  } else {
    init();
    debug();
  }
})();
